// extracted by mini-css-extract-plugin
export default {"progressCircle":"ProgressCircle_progressCircle__5lVLo","progressAccent":"ProgressCircle_progressAccent__7Vbm8"};